import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { SubscriptionAndProfessionalServicesAgreement } from '@/screens/Legal/SubscriptionAndProfessionalServicesAgreement';

export default function SubscriptionAndProfessionalServicesAgreementPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="Subscription, Professional Services Agreement"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Subscription and Professional Services Agreement | Loadsmart"
        description="Subscription and Professional Services Agreement at Loadsmart"
        canonical="https://loadsmart.com/subscription-and-professional-services-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/subscription-and-professional-services-agreement/',
        }}
      />
      <SubscriptionAndProfessionalServicesAgreement />
    </>
  );
}
